export default (tourCriteria) => {
    let element;
    const params = {};

    element = tourCriteria.get('departureCity');
    if (element) {
        params.departureCity = {
            id: element.get('id'),
            name: element.get('name'),
        };
    }

    element = tourCriteria.get('countries');
    if (element && element.length) {
        params.countries = element.pluck('id');
    }

    element = tourCriteria.get('resorts');
    if (element && element.length) {
        params.resorts = element.pluck('id');
    }

    element = tourCriteria.get('hotels');
    if (element && element.length) {
        params.hotels = element.pluck('id');
    }

    element = tourCriteria.get('checkInDateRange');
    if (element) {
        params.checkInDateRange = {};
        const from = element.get('from');
        const to = element.get('to');
        if (from) {
            params.checkInDateRange.from = $.datepicker.formatDate('dd.mm.yy', from);
        }
        if (to) {
            params.checkInDateRange.to = $.datepicker.formatDate('dd.mm.yy', to);
        }
    }

    element = tourCriteria.get('nightRange');
    if (element) {
        params.nightRange = {};
        const from = element.get('from');
        const to = element.get('to');
        if (from) {
            params.nightRange.from = from;
        }
        if (to) {
            params.nightRange.to = to;
        }
    }

    element = tourCriteria.get('touristGroup');
    if (element) {
        params.touristGroup = {};
        const adults = element.get('adults');
        const kids = element.get('kids');
        const infants = element.get('infants');
        const ages = element.get('ages');

        if (adults) {
            params.touristGroup = {
                adults,
                kids,
                infants,
                ages,
            };
        }
    }

    return params;
};